<template>
  <div>
    <svg viewBox="0 0 6000 6000" :width="svgWidth" :height="svgHeight">
      <defs>
        <linearGradient id="Gradient1">
          <stop
            offset="0%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.darken3"
          />
          <stop
            offset="100%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.darken2"
          />
        </linearGradient>
        <linearGradient id="Gradient2">
          <stop
            offset="0%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.darken1"
          />
          <stop
            offset="100%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.base"
          />
        </linearGradient>
        <linearGradient id="Gradient3">
          <stop
            offset="0%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.lighten1"
          />
          <stop
            offset="100%"
            :stop-color="this.$vuetify.theme.themes.dark.secondary.lighten2"
          />
        </linearGradient>
      </defs>
      <g>
        <path
          class="gradient3"
          d="M5016.84,4862c-4.94.71-7.48,1.4-10,1.4q-986.9-.14-1973.8-.44c-1.14,0-2.28-1.12-4.46-2.27a72.09,72.09,0,0,1-1.26-8.82c-.22-7.33-.11-14.66-.11-22q0-1613.86-.23-3227.73c0-19.67,2.81-38.17,9.44-56.6,9.48-26.33,18.56-52.79,31.89-77.49,59.76-110.72,150.41-181.15,273.5-208.9,9.65-2.17,19.76-2.75,29.69-3.07,150.6-5,301.27-4.22,451.92-4.32q323-.23,645.94,1c71.32.25,142.63,2.41,213.94,3.67,22.94.4,45,5.87,66.31,13.47,106.32,37.86,186.76,105.85,238.59,206.7,5.79,11.26,10.74,23,16.95,34,6.77,12,9.24,24.38,9.23,38.16-.07,126.66.45,253.32.55,380q1.1,1320.89,2.08,2641.77.12,134,.3,268C5017.29,4845.64,5017,4852.91,5016.84,4862ZM3423.54,2653.47c11.87.16,21.1.4,30.34.4q571.77,0,1143.54,0c6,0,12,.16,18-.13a104.62,104.62,0,0,0,10.8-1.55c3.1-23.5,4.55-859,1.85-984.69-.09-3.87-.75-7.72-1.13-11.49-2.6-.89-4.45-2.07-6.3-2.07q-593.76-.23-1187.51-.2c-2.54,0-5.08,1-8.24,1.63-.48,3.57-1.28,6.75-1.28,9.94C3423.54,1993.75,3423.54,2322.18,3423.54,2653.47Zm501.58,719.18c3.59,10.29,8,20,10.32,30.15,8.49,37.65,16.64,75.38,24.22,113.23,15.4,77,30.4,154.08,45.47,231.14,15.7,80.34,31,160.74,47,241,12.59,63.3,26.34,126.38,38.62,189.74,4.33,22.38,16.51,38.85,32.8,53.22,14.71,13,31.86,19.05,51.57,16.88,5.28-.59,10.55-1.42,15.74-2.5,31.48-6.59,60.9-19.16,90.3-31.62,49.63-21,99-42.75,148.62-63.78,18.25-7.73,21.93-14,41.65,7.54,9.07,9.9,19.91,12.75,32.53,10.57a80.91,80.91,0,0,0,15.46-3.83q44.64-17.31,89.07-35.18a74.59,74.59,0,0,0,15.51-9c9.57-6.95,13.32-16.5,10.13-28.05a259,259,0,0,0-8.08-24.65c-24.08-62-47.93-124.16-72.57-186-37.71-94.58-76.15-188.87-113.93-283.42-10.08-25.25-14.6-22.44,7.58-52a175.21,175.21,0,0,0,13.67-21.94c5.65-10.48,4.67-20.44-3.84-29.34-8.29-8.66-16-17.87-24.68-26.15q-93.89-89.92-196.14-170.25c-8.37-6.56-17.38-12.32-26.24-18.22-9.59-6.38-19.1-5.23-27.69,1.8a209.58,209.58,0,0,0-17.41,16.45c-13,13.38-25.62,27.12-38.73,40.38-5.54,5.6-11.05,11.62-19.29,13.8-8.19-1.8-14.2-7.25-20.43-12.08-17.89-13.89-35.52-28.11-53.38-42-7.28-5.68-14.48-11.62-23-14.61C3987.24,3297.74,3937.71,3349.83,3925.12,3372.65Zm50-122.33c-2.66-2.5-5.34-5.38-8.37-7.83-40.94-33.12-82.07-66-122.77-99.41-8.56-7-18-11-28.3-14-82.46-24-164.86-48.18-247.37-72-31.33-9-63-16.91-94.36-25.88-13.36-3.82-23.86.24-32.18,10A93.15,93.15,0,0,0,3428,3063c-8.61,19.08-11.77,39.38-12,60.31-.1,10.71,4.41,17.9,13.77,22.17,8.46,3.86,16.95,7.87,25.79,10.67q58.07,18.42,116.34,36.12c52.2,15.94,104.5,31.58,156.7,47.52a287.28,287.28,0,0,1,98.11,52.38c18.11,14.72,36.38,29.22,54.64,43.74,3.52,2.8,7.32,5.24,10.75,7.66C3929.24,3312,3965.58,3271.22,3975.11,3250.32Zm-446.28,128.2c-12.82,4.88-18.93,13.76-25.24,22.13-28.57,37.89-51.9,78.9-71.12,122.23a201,201,0,0,0-15,51.6c-7.25,48,10.89,85,52.8,106a186.38,186.38,0,0,0,29.52,11.88c30,9,57.92,4,83.49-13.91,15.44-10.81,28.24-24.33,39.05-39.67A54.55,54.55,0,0,0,3632.4,3611c2-26.2.24-52-9.59-76.57-5.42-13.57-11.37-27-18.11-40-18.16-34.89-39.75-67.69-62.58-99.68C3538.31,3389.45,3533.83,3384.59,3528.83,3378.52Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient2"
          d="M2817.54,2400.39c1.24,4.13,2.28,6,2.28,7.82q.1,1223.73,0,2447.47c0,1.84-1.07,3.67-1.85,6.2-6.94,2.73-14.32,1.52-21.47,1.49q-166-.55-331.93-1.37-186.95-1-373.91-2.63c-26.63-.24-53.25-2.28-79.88-3.52-16.57-.77-31.11-6.23-43.22-18-31.06-30.16-33.28-30.47-35-74.24-2.37-59.26-3.85-118.59-4.08-177.89-2.41-607.87-4.85-1215.73-3-1823.6.27-86,1.42-172,1.86-257.94.23-44.87,26.45-72,62.24-92.68,4.39-2.53,10.13-3.27,15.34-3.73,17.25-1.51,34.52-3.1,51.82-3.61,150.59-4.38,301.23-3.75,451.87-3.78q143,0,285.94,0Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient1"
          d="M1700.27,3521.24c.53,4.27,1.31,8.08,1.44,11.91,2.79,81.95,1.08,1309-1.83,1327.54-6.4,5-14,2.64-21.07,2.63q-112-.1-223.92-.7-238.92-1.4-477.84-3.18c-28-.23-55.91-2.35-83.87-3.53-17.33-.73-32.31-6.69-44.94-18.85-32.87-31.65-33.32-33.75-35.41-74.31-2.71-52.55-3.84-105.24-3.94-157.88q-.84-473.83-.86-947.69c0-13.33.45-26.65.39-40,0-10.94,2.85-21.07,7.6-30.74,9.9-20.17,24.5-36.28,42.61-49.45,13.65-9.92,29.43-12,45.49-12.57,43.29-1.51,86.59-3.37,129.89-3.78,85.31-.82,170.62-.92,255.92-1q192.94-.22,385.88,0C1683.65,3519.65,1691.65,3518.72,1700.27,3521.24Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient3"
          d="M4107.65,3727.26c4.05,2.52,7,3.89,9.36,5.91,18.74,16,37.28,32.19,56.06,48.11a76.4,76.4,0,0,1,22.48,32.39c16.68,44.86,34.12,89.45,50.12,134.55,18,50.74,34.78,101.9,52,152.93,2.51,7.47,4.32,15.19,6.58,23.21-5,2.94-8.77,5.66-12.91,7.49-24.34,10.73-48.71,21.38-73.2,31.74a131.43,131.43,0,0,1-20.87,6.7c-17.88,4.22-29.46-.76-37.91-17.45a129.36,129.36,0,0,1-11-29.81c-6-26.58-11.54-53.29-16-80.16q-12.14-72.79-22.72-145.86c-4.8-32.9-9.35-65.88-12.42-99C4094.76,3771.93,4093.93,3763.09,4107.65,3727.26Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient3"
          d="M4349.72,4098.48q-10.7-31.08-21.38-62.14c-25.4-74.29-51-148.52-76-223-6.74-20-16.94-37.48-32.07-52.14-11.48-11.13-23-22.24-34.28-33.54-8.48-8.47-16.91-17-24.83-26-2.84-3.23-4.15-7.82-6-11.4,1.8-1.89,2.53-3.33,3.64-3.72,32.67-11.78,65.92-15.78,99.9-6.34a90.68,90.68,0,0,1,38.06,21.15c8.51,7.92,14,17.71,18,28.4,13.13,34.88,26.57,69.65,39.18,104.71,22.74,63.24,45.18,126.6,63.63,191.27,3.28,11.47,5.34,23.31,7.51,35.07.88,4.77-.48,9.47-5.13,12.1-20.84,11.76-41.75,23.41-65.95,26.94C4353.49,4100,4352.82,4099.52,4349.72,4098.48Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient3"
          d="M4082.36,3659.62c-.25,1.88-.45,4.54-1,7.14-.91,4.69-2.31,9.15-7.81,10.4-6.18,1.4-12.37-.87-15.35-6.43a91,91,0,0,1-7.06-16.44c-7.93-26-15.78-52.1-23.13-78.3-3.22-11.49-5.51-23.28-7.57-35a73,73,0,0,1-.57-17.85c.15-2.1,2.49-4.93,4.54-5.84,8.8-3.9,19.63-1,24.79,6.8a58.61,58.61,0,0,1,6.84,14.3c12,37.39,21.31,75.42,25.77,114.52C4082.07,3654.86,4082.15,3656.85,4082.36,3659.62Z"
          transform="translate(0 0)"
        />
        <path
          class="gradient3"
          d="M4027.14,3470.83c-21.56,2.24-28.67-2.07-34.85-20.46a91.65,91.65,0,0,1-4.43-37.12,31.68,31.68,0,0,1,4.29-12.83c3.72-6.36,11.75-7.18,16.77-1.57a54.66,54.66,0,0,1,9.7,14.74,135.52,135.52,0,0,1,10.44,50.09C4029.12,3466.13,4027.77,3468.61,4027.14,3470.83Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "NameSvg",
  props: {
    width: Number,
    height: Number,
  },
  computed: {
    svgWidth: function () {
      if (this.width && this.width > 0) {
        return this.width;
      }
      return "100%";
    },
    svgHeight: function () {
      if (this.height && this.height > 0) {
        return this.height;
      }
      return "100%";
    },
  },
};
</script>

<style type="text/css">
.gradient1 {
  fill: url(#Gradient1);
}
.gradient2 {
  fill: url(#Gradient2);
}
.gradient3 {
  fill: url(#Gradient3);
}
.text {
  fill: var(--v-text-base);
}

#header-shape-gradient {
  --color-stop: #f12c06;
  --color-bot: #faed34;
}
</style>
